import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/chevron-down.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M17.293 8.29295C17.6835 7.90243 18.3166 7.90243 18.7071 8.29295C19.0976 8.68348 19.0976 9.31649 18.7071 9.70702L12.7071 15.707C12.3166 16.0975 11.6835 16.0975 11.293 15.707L5.29302 9.70702C4.90249 9.31649 4.90249 8.68348 5.29302 8.29295C5.68354 7.90243 6.31655 7.90243 6.70708 8.29295L12 13.5859L17.293 8.29295Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as ChevronDownIcon };
